import Navbar from './components/nav/Navbar'
import Routing from './components/routing'
import Footer from './components/Footer'

function App() {
  return (
    <>
      <Navbar />
      <Routing />
      <Footer />
    </>
  );
}

export default App;
